// dependencies
import React from "react";
import moment from "moment";
import { Link } from "yarrr";
import { Map } from "immutable";
import PropTypes from "prop-types";

// components
import Avatar from "Components/Avatar";

// style
import css from "./User";

export default class Request extends React.Component {
	static propTypes = {
		className: PropTypes.string,
		user: PropTypes.instanceOf(Map).isRequired,
	};

	static defaultProps = {
		className: "",
	};

	state = {
		hasError: false,
	};

	componentDidCatch = () => {
		this.setState({ hasError: true });
	};

	render = () => {
		const { user, className } = this.props;
		const { hasError } = this.state;

		if (hasError) {
			return null;
		}

		const lastSeen = user.get("last_seen", null);
		const userStatus = user.get("deactivated") ? "Deactivated" : "Active";
		const invitationStatus = user.get("invited") ? "Yes" : "No";
		const invitationDate = user.get("invited_on")
			? "- " + moment(user.get("invited_on")).format("MM/DD/YYYY hh:mm A")
			: "";
		const invitationSent = invitationStatus + " " + invitationDate;

		return (
			<div className={`${css.main} ${className}`}>
				<div className={css.userContent}>
					<Avatar className={`${css.lowerItem} ${css.avatar}`} size={30} userID={user.getIn(["id"])} />
					<div className={css.userName}>
						<Link className={css.name} href={`/breadcrumbs/${user.get("id")}/`}>
							{user.get("name")}
						</Link>
					</div>
					<div className={css.textValue}>{userStatus}</div>
					<div className={css.textValue}>{invitationSent}</div>
					<div className={`${css.textValue} ${css.alignRight}`}>
						{lastSeen ? moment(lastSeen).calendar() : null}
					</div>
				</div>
			</div>
		);
	};
}
